const translations: Record<string, string> = {
  'common:siteName': '免费PDF工具',
  'common:nav.home': '首页',
  'common:nav.pdfToWord': 'PDF转Word',
  'common:nav.pdfToExcel': 'PDF转Excel',
  'common:nav.pdfToPpt': 'PDF转PPT',
  'common:nav.imageConvert': '图片转换',
  'common:nav.pdfTools': 'PDF工具',
  'common:nav.tutorials': '使用教程',
  'common:nav.faq': '常见问题',

  'common:footer.description': '最好的免费PDF工具，满足您所有的PDF转换和编辑需求。无需注册。',
  'common:footer.quickLinks': '快速链接',
  'common:footer.about': '关于',
  'common:footer.aboutUs': '关于我们',
  'common:footer.tutorials': '教程',
  'common:footer.faq': '常见问题',
  'common:footer.privacyPolicy': '隐私政策',
  'common:footer.subscribe': '订阅',
  'common:footer.subscribeNote': '获取最新技巧和更新。',
  'common:footer.subscribePlaceholder': '输入您的邮箱',
  'common:footer.subscribeButton': '订阅',
  'common:footer.subscribing': '订阅中...',
  'common:footer.subscribeSuccess': '✓ 订阅成功！',
  'common:footer.subscribeFailed': '订阅失败，请重试。',
  'common:footer.subscribeError': '网络错误，请重试。',
  'common:footer.adSpace': '广告位',
  'common:footer.copyright': '© 2024 免费PDF工具。保留所有权利。',

  'common:features.pdfToDoc': 'PDF转文档',
  'common:features.pdfToDocDesc': '将PDF转换为Word、Excel、PPT等可编辑格式。',
  'common:features.imageToPdf': '图片转PDF',
  'common:features.imageToPdfDesc': '轻松将多张图片合并为一个PDF文件。',
  'common:features.pdfMerge': '合并与拆分PDF',
  'common:features.pdfMergeDesc': '合并多个PDF或将一个PDF拆分为多个文件。',
  'common:features.startConvert': '开始转换',
  'common:features.useNow': '立即使用',
  'common:features.mostPopular': '最受欢迎',

  'home:hero.title': '免费在线PDF工具',
  'home:hero.subtitle': '轻松转换、编辑和管理您的PDF文件。无需注册，100%免费！',
  'home:hero.free': '永久免费',
  'home:hero.noRegistration': '无需注册',
  'home:hero.secure': '安全私密',
  'home:hero.startConverting': '开始转换',
  'home:hero.viewAllTools': '查看所有工具',
  'home:hero.stats.users': '满意用户',
  'home:hero.stats.conversions': '已转换文件',
  'home:hero.stats.rating': '用户评分',

  'home:allTools.title': '所有PDF工具',
  'home:allTools.subtitle': '处理PDF文件所需的一切，完全免费。',
  'home:allTools.tryNow': '立即试用',
  'home:tools.pdfToWord.name': 'PDF转Word',
  'home:tools.pdfToWord.description': '将PDF转换为可编辑的Word文档。',
  'home:tools.pdfToExcel.name': 'PDF转Excel',
  'home:tools.pdfToExcel.description': '从PDF中提取表格到Excel电子表格。',
  'home:tools.pdfToPpt.name': 'PDF转PPT',
  'home:tools.pdfToPpt.description': '将PDF转换为PowerPoint演示文稿。',
  'home:tools.pdfToImage.name': 'PDF转图片',
  'home:tools.pdfToImage.description': '将PDF页面转换为JPG或PNG图片。',
  'home:tools.imageToPdf.name': '图片转PDF',
  'home:tools.imageToPdf.description': '将图片合并为一个PDF文件。',
  'home:tools.mergePdf.name': '合并PDF',
  'home:tools.mergePdf.description': '将多个PDF文件合并为一个。',
  'home:tools.splitPdf.name': '拆分PDF',
  'home:tools.splitPdf.description': '从PDF文件中提取页面。',
  'home:tools.compressPdf.name': '压缩PDF',
  'home:tools.compressPdf.description': '在不损失质量的情况下减小PDF文件大小。',

  'home:whyUs.title': '为什么选择我们？',
  'home:whyUs.subtitle': '我们提供最好的免费PDF工具，无隐藏费用，无需注册。',
  'home:whyUs.free.title': '100%免费',
  'home:whyUs.free.description': '所有工具完全免费。没有隐藏费用，没有订阅。',
  'home:whyUs.fast.title': '极速处理',
  'home:whyUs.fast.description': '我们的服务器在几秒钟内处理您的文件。',
  'home:whyUs.secure.title': '安全私密',
  'home:whyUs.secure.description': '转换后您的文件会自动删除。',
  'home:whyUs.easy.title': '简单易用',
  'home:whyUs.easy.description': '简单的拖放界面，无需任何技术技能。',
  'home:whyUs.cta.title': '准备好开始了吗？',
  'home:whyUs.cta.description': '加入每天信任我们免费PDF工具的数百万用户。',
  'home:whyUs.cta.button': '免费试用',

  'home:testimonials.title': '用户评价',
  'home:testimonials.subtitle': '受到全球数百万用户的信赖。',
  'home:testimonials.trustedBy': '受信任并认证于',
  'home:testimonials.badges.secure': 'SSL安全',
  'home:testimonials.badges.verified': '已验证安全',
  'home:testimonials.badges.award': '顶级工具',
  'home:testimonials.user1.name': 'Sarah Johnson',
  'home:testimonials.user1.role': '市场经理',
  'home:testimonials.user1.content': '这是我用过的最好的免费PDF工具。快速、可靠，不需要烦人的注册！',
  'home:testimonials.user2.name': 'Emily Chen',
  'home:testimonials.user2.role': '自由设计师',
  'home:testimonials.user2.content': '我每天为客户将PDF转换为Word。这个工具节省了我很多时间，而且完全免费！',
  'home:testimonials.user3.name': 'Michael Torres',
  'home:testimonials.user3.role': '业务分析师',
  'home:testimonials.user3.content': 'PDF转Excel功能非常准确，每次都能完美提取表格。',

  'home:ads.topBanner': '广告',
  'home:ads.middleBanner': '广告',

  'upload:dragDrop': '拖放您的PDF文件到这里',
  'upload:or': '或',
  'upload:selectFile': '选择文件',
  'upload:processing': '处理中...',
  'upload:converting': '正在转换您的文件...',
  'upload:done': '完成！',
  'upload:success': '您的文件已成功转换',
  'upload:download': '下载文件',
  'upload:convertAnother': '转换其他文件',
  'upload:fileSize': '最大文件大小：10MB',
  'upload:supportedFormats': '支持的格式',

  'pdfToWord:title': 'PDF转Word',
  'pdfToWord:description': '免费将您的PDF文件转换为可编辑的Word文档',
  'pdfToWord:feature1.title': '快速转换',
  'pdfToWord:feature1.desc': '几秒钟内将PDF转换为Word',
  'pdfToWord:feature2.title': '高质量',
  'pdfToWord:feature2.desc': '保留原始格式和布局',
  'pdfToWord:feature3.title': '100%免费',
  'pdfToWord:feature3.desc': '无需注册或付费',
  'pdfToWord:howTo.title': '使用方法',
  'pdfToWord:howTo.step1': '上传您的PDF文件',
  'pdfToWord:howTo.step2': '等待转换完成',
  'pdfToWord:howTo.step3': '下载您的Word文件',

  'pdfToExcel:title': 'PDF转Excel',
  'pdfToExcel:description': '将PDF表格转换为可编辑的Excel电子表格',
  'pdfToExcel:feature1.title': '提取表格',
  'pdfToExcel:feature1.desc': '自动从PDF中提取表格',
  'pdfToExcel:feature2.title': '数据准确',
  'pdfToExcel:feature2.desc': '保留原始数据结构',
  'pdfToExcel:feature3.title': '易于使用',
  'pdfToExcel:feature3.desc': '简单直观的界面',
  'pdfToExcel:howTo.title': '使用方法',
  'pdfToExcel:howTo.step1': '上传包含表格的PDF文件',
  'pdfToExcel:howTo.step2': '系统将提取表格',
  'pdfToExcel:howTo.step3': '下载您的Excel文件',

  'pdfToPpt:title': 'PDF转PowerPoint',
  'pdfToPpt:description': '将您的PDF转换为可编辑的PowerPoint演示文稿',
  'pdfToPpt:feature1.title': '幻灯片转换',
  'pdfToPpt:feature1.desc': '每个PDF页面变成一个PPT幻灯片',
  'pdfToPpt:feature2.title': '可编辑',
  'pdfToPpt:feature2.desc': '转换后可编辑文本和图片',
  'pdfToPpt:feature3.title': '安全私密',
  'pdfToPpt:feature3.desc': '转换后文件将被删除',
  'pdfToPpt:howTo.title': '使用方法',
  'pdfToPpt:howTo.step1': '选择您的PDF文件',
  'pdfToPpt:howTo.step2': '转换为PPT格式',
  'pdfToPpt:howTo.step3': '下载您的演示文稿',

  'imageConvert:title': '图片转换器',
  'imageConvert:description': '轻松将图片转换为PDF或将PDF转换为图片',
  'imageConvert:feature1.title': '多格式支持',
  'imageConvert:feature1.desc': '支持JPG、PNG、BMP、GIF',
  'imageConvert:feature2.title': '批量转换',
  'imageConvert:feature2.desc': '一次转换多个图片',
  'imageConvert:feature3.title': '质量保证',
  'imageConvert:feature3.desc': '图片质量无损',
  'imageConvert:howTo.title': '使用方法',
  'imageConvert:howTo.step1': '上传图片或PDF',
  'imageConvert:howTo.step2': '选择输出格式',
  'imageConvert:howTo.step3': '下载转换后的文件',

  'pdfToolsPage:title': '完整PDF工具',
  'pdfToolsPage:description': '合并、拆分、压缩和编辑您的PDF文件',
  'pdfToolsPage:feature1.title': '合并PDF',
  'pdfToolsPage:feature1.desc': '将多个PDF合并为一个',
  'pdfToolsPage:feature2.title': '拆分PDF',
  'pdfToolsPage:feature2.desc': '从PDF中提取页面',
  'pdfToolsPage:feature3.title': '压缩PDF',
  'pdfToolsPage:feature3.desc': '减小PDF文件大小',
  'pdfToolsPage:howTo.title': '使用方法',
  'pdfToolsPage:howTo.step1': '选择您需要的工具',
  'pdfToolsPage:howTo.step2': '上传您的PDF文件',
  'pdfToolsPage:howTo.step3': '下载处理后的结果',

  'upload.dragDrop': '拖放您的PDF文件到这里',
  'upload.or': '或',
  'upload.selectFile': '选择PDF文件',
  'upload.fileSize': '最大文件大小：20MB',
  'upload.uploading': '上传中...',
  'upload.processing': '处理中...',
  'upload.converting': '转换中...',
  'upload.preparing': '准备下载...',
  'upload.done': '转换完成！',
  'upload.download': '下载',
  'upload.convertAnother': '转换另一个文件',
  'upload.convertedTo': '已转换为',
  'upload.error': '转换失败',
  'upload.retry': '重试',
  'upload.selectAnother': '选择另一个文件',
  'upload.fileTooLarge': '文件大小超过20MB限制',
  'upload.invalidFormat': '无效的文件格式',
  'upload.networkError': '网络错误，请重试',
  'upload.conversionFailed': '转换失败，请重试',
  'upload.howItWorks': '如何使用',
  'upload.step1': '上传文件',
  'upload.step1Desc': '选择或拖放您的PDF文件',
  'upload.step2': '转换',
  'upload.step2Desc': '我们自动处理您的文件',
  'upload.step3': '下载',
  'upload.step3Desc': '立即获取转换后的文件',
  'upload.downloading': '准备下载...',
  'upload.progress': '进度：{percent}%',

  'imageConvert.pdfToImage': 'PDF转图片',
  'imageConvert.imageToPdf': '图片转PDF',
  'imageConvert.selectImages': '选择图片',
  'imageConvert.multipleFilesHint': '支持多张图片合并为一个PDF',
  'imageConvert.processingFiles': '正在处理 {count} 个文件...',

  'pdfToPpt.feature1': '保留布局',
  'pdfToPpt.feature2': '保留图片',
  'pdfToPpt.feature3': '可编辑演示文稿',
};

export default translations;
